export enum DeferredRequestKey {
  CreditStatus = 'creditStatus',
  DeliveryPickup = 'deliveryPickup',
  Discounts = 'discounts',
  Favorites = 'favorites',
  OwnerReviews = 'ownerReviews',
  Pricing = 'pricing',
  RecentSearches = 'recentSearches',
  SavedSearches = 'savedSearches',
  Trades = 'trades',
  WhyBuy = 'whyBuy'
}

export const VDP_DEFERRED_REQUEST_KEYS = [
  DeferredRequestKey.DeliveryPickup,
  DeferredRequestKey.Discounts,
  DeferredRequestKey.Favorites,
  DeferredRequestKey.OwnerReviews,
  DeferredRequestKey.Pricing,
  DeferredRequestKey.Trades,
  DeferredRequestKey.WhyBuy
] as const;

export type VdpDeferredRequestKey = (typeof VDP_DEFERRED_REQUEST_KEYS)[number];
